import { render, staticRenderFns } from "./index.vue?vue&type=template&id=45953fe6&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=45953fe6&prod&lang=scss&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=45953fe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45953fe6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumb: require('/drone/src/components/Breadcrumb/index.vue').default,PzImage: require('/drone/src/components/PzImage/index.vue').default,GoodsQqGroup: require('/drone/src/components/GoodsDesc/GoodsQqGroup.vue').default,ViewMore: require('/drone/src/components/ViewMore/index.vue').default,GoodsZoom: require('/drone/src/components/GoodsZoom/index.vue').default,TextOverflow: require('/drone/src/components/TextOverflow/index.vue').default,SimilarBox: require('/drone/src/components/SimilarBox/index.vue').default,ConjoinedGoodsDisplayModule: require('/drone/src/components/ConjoinedGoods/displayModule.vue').default,PzTabs: require('/drone/src/components/pz-tabs/index.vue').default,GoodsWrap: require('/drone/src/components/GoodsWrap/index.vue').default,GoodsIntroduce: require('/drone/src/components/GoodsDesc/GoodsIntroduce.vue').default,GoodsTransaction: require('/drone/src/components/GoodsDesc/GoodsTransaction.vue').default,TimeCountdown: require('/drone/src/components/TimeCountdown/index.vue').default,BargainDialog: require('/drone/src/components/BargainDialog.vue').default})
